import {
  SAVE_REDO_CONFIG_REQUEST,
  SAVE_REDO_CONFIG_SUCCESS,
  SAVE_REDO_CONFIG_FAILURE,
  REDO_DISCONNECT_REQUEST,
  REDO_DISCONNECT_SUCCESS,
  REDO_DISCONNECT_FAILURE
} from '../actions/redoActions';

const initialState = {
  redoData: null,
  saving: false,
  error: null,
  validationErrors: null,
  lastMessage: null
};

const redoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_REDO_CONFIG_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null
      };

    case SAVE_REDO_CONFIG_SUCCESS:
      return {
        ...state,
        saving: false,
        redoData: action.payload.data || state.redoData,
        error: null,
        validationErrors: null,
        lastMessage: action.payload.message || 'Redo configuration saved successfully'
      };

    case SAVE_REDO_CONFIG_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload,
        validationErrors: action.payload.validationErrors || null,
        lastMessage: null
      };

    case REDO_DISCONNECT_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        lastMessage: null
      };

    case REDO_DISCONNECT_SUCCESS:
      return {
        ...state,
        saving: false,
        lastMessage: action.payload?.message || 'Disconnected successfully'
      };

    case REDO_DISCONNECT_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error || 'Failed to disconnect',
        lastMessage: null
      };

    default:
      return state;
  }
};

export default redoReducer;
